export const ProjectPriceDirection = {
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING',
};

export const ProjectPriceDirectionField = [
  { label: 'Kimenő', value: ProjectPriceDirection.OUTGOING },
  { label: 'Bejövő', value: ProjectPriceDirection.INCOMING },
];
